import {ApiClient as Api} from '@hconnect/apiclient'
import {useNotification} from '@hconnect/uikit'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {SlaKpiCommentsByMonthDto, SlaTrackingQueryKey, TabTypeDto} from '../../types'

type Params = {
  plantUpmId: string
  tabType?: TabTypeDto
  kpiDefinitionId?: string
  from?: string
  to?: string
}

export const useSlaKpiComments = (
  {plantUpmId, tabType, kpiDefinitionId, from, to}: Params,
  options?: Omit<UseQueryOptions<SlaKpiCommentsByMonthDto[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const {notify} = useNotification()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const query = useQuery<SlaKpiCommentsByMonthDto[], AxiosError>({
    queryKey: [
      SlaTrackingQueryKey.SlaKpiComments,
      plantUpmId,
      tabType ?? null,
      kpiDefinitionId ?? null,
      from ?? null,
      to ?? null
    ],
    queryFn: async ({signal}) => {
      const params = {
        ...(tabType ? {tabType} : {}),
        ...(kpiDefinitionId ? {kpidefinitionid: kpiDefinitionId} : {}),
        ...(from ? {from} : {}),
        ...(to ? {to} : {})
      }

      const path = `/sla-kpi-tracking/api/${plantUpmId}/sla-kpi/tab-values/comments`
      const response = await Api.axiosInstance.get<SlaKpiCommentsByMonthDto[]>(path, {
        params,
        signal
      })
      return response.data
    },
    ...options
  })

  useEffect(() => {
    if (query.error) {
      notify('error', t('comments.message.failedToFetchComments'))
    }
  }, [notify, query.error, t])

  return query
}
